import React from 'react';
import { inject, observer } from 'mobx-react';

import AdStore from '../../../store/AdStore';
import { modelOf } from '../../../prop-types';
import HeaderNavLink from '../HeaderNavLink';
import LinkType from '../../../types/LinkType';

const NavigationLinkStatic = ({ adStore }) => {
  // Component supports only one ad.
  const ad = adStore.textBanners[0];

  const adToLink = () => {
    const type = ad.is_external
      ? LinkType.EXTERNAL_LINK
      : LinkType.INTERNAL_LINK;
    const Wrapper = ({ children }) => (
      <div className="NavigationLinkStatic__link">
        {ad.link_url ? (
          <HeaderNavLink
            surface="top"
            accessible={true}
            to={ad.link_url}
            type={type}
          >
            {children}
          </HeaderNavLink>
        ) : (
          children
        )}
      </div>
    );
    return (
      <Wrapper key={ad.id}>
        <div
          className="NavigationLinkStatic__content"
          dangerouslySetInnerHTML={{ __html: ad.content }}
          draggable={false}
        />
      </Wrapper>
    );
  };

  return (
    <div id="NavigationLinkStatic" className="NavigationLinkCarousel">
      {adToLink()}
    </div>
  );
};

NavigationLinkStatic.propTypes = {
  adStore: modelOf(AdStore).isRequired,
};

export default inject('adStore')(observer(NavigationLinkStatic));
